import { Asterisk } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export default function Marquee() {
  const { content, t } = useSite();
  const items = content?.marquee || [];

  const Track = ({ hidden }) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
      {items.map((m, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display uppercase text-2xl sm:text-3xl tracking-wide text-brand-navy px-6 whitespace-nowrap">
            {t(m)}
          </span>
          <Asterisk size={26} className="text-white shrink-0" strokeWidth={2.5} />
        </span>
      ))}
    </div>
  );

  return (
    <div className="overflow-hidden py-10 -my-4">
      <div className="-rotate-1 -mx-6 bg-[linear-gradient(90deg,#2E9BE8_0%,#F97316_55%,#E63946_100%)] py-4 shadow-[0_20px_50px_-20px_rgba(0,0,0,0.7)] overflow-hidden">
        <div className="marquee-track">
          <Track />
          <Track hidden />
        </div>
      </div>
    </div>
  );
}
